/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/MoveToAnotherTreatment/Events/Content/Event/Appointment/Content/Time/Content"
  
}) {
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let appointmentBookingLocalStartDateValueData = fromData.useDataValue({ viewPath,
context: 'appointment',
path: 'booking.local_start_date',
})
let appointmentBookingLocalStartTimeValueData = fromData.useDataValue({ viewPath,
context: 'appointment',
path: 'booking.local_start_time',
})
let aggregateData = fromHelpers.formatDate(appointmentBookingLocalStartDateValueData, appointmentBookingLocalStartTimeValueData)
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let appointmentBookingLocalStartDateValueData1 = fromData.useDataValue({ viewPath,
context: 'appointment',
path: 'booking.local_start_date',
})
let appointmentBookingLocalStartTimeValueData1 = fromData.useDataValue({ viewPath,
context: 'appointment',
path: 'booking.local_start_time',
})
let aggregateData1 = fromHelpers.formatYear(appointmentBookingLocalStartDateValueData1, appointmentBookingLocalStartTimeValueData1)
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--pr-1-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="large"
 weight="bold"
 color={dtColorsNeutral500}
 data="appointment.booking.local_start_date"
 data="appointment.booking.local_start_time"
 aggregate="helpers.js formatDate"
 text={aggregateData}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 weight="semibold"
 color={dtColorsNeutral500}
 data="appointment.booking.local_start_date"
 data="appointment.booking.local_start_time"
 aggregate="helpers.js formatYear"
 text={aggregateData1}
/>
</div>
{children}
</React.Fragment>)
}